import React from "react";
import Typography from "../../typography";
import Content from "../../content";
import uhOh from "./assets/title.svg";
import styles from "./ErrorMessage.module.css";

interface ErrorMessageProps {
  // type?: "notFound" | "serverError";
  description: React.ReactNode | string;
  alt: string;
  renderActions?: () => React.ReactNode;
  asset?: React.ReactNode;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({
  description,
  renderActions = () => null,
  alt,
  asset,
}) => {
  return (
    <Content className={styles.wrapper}>
      <div className={styles.message}>
        <img src={uhOh} alt={alt} />
        <Typography variant="h5" component="h1" className={styles.text}>
          {description}
        </Typography>
        <div className={styles.actions}>{renderActions()}</div>
      </div>
      <div className={styles.imageHolder}>{asset}</div>
    </Content>
  );
};

export default ErrorMessage;
